import { render, staticRenderFns } from "./Participants.vue?vue&type=template&id=ab24ee94&scoped=true"
import script from "./Participants.vue?vue&type=script&lang=js"
export * from "./Participants.vue?vue&type=script&lang=js"
import style0 from "./Participants.vue?vue&type=style&index=0&id=ab24ee94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab24ee94",
  null
  
)

export default component.exports